module.exports = __webpack_public_path__ + "media/src/assets/images/error-img-c7ae99ce871c7f754a0271483f7d136f.png";